import './App.css';
import Footer from './components/Footer';
import React, { useEffect } from 'react';
import { useTranslation } from "react-i18next";
import "./i18n";

import {
  HashRouter as Router,
  Routes,
  Route,
} from "react-router-dom";

import Main from './pages/MainPage';
import ContactPage from './pages/ContactPage';
import ProductPage from './pages/ProductPage';
import CarierPage from './pages/CarierPage';

export default function App() {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = t('main_company');
  }, []);
  return (
    <Router>
        <Routes>
          <Route exact path="/" element={<Main/>} />
          <Route exact path="/contacts" element={<ContactPage/>} />
          <Route exact path="/products" element={<ProductPage/>} />
          <Route exact path="/carier" element={<CarierPage/>} />
        </Routes>
        
      <Footer/>
    </Router>
  )
}
